import * as types from '../constants/ActionTypes-privilegePartyMember';

// Definir el estado inicial
const initialState = {
  itemPartyMembers: [], // Inicialmente vacío
  loading: false,
  error: null,
};

// Definir el reducer
const privilegePartyMemberReducer = (state = initialState, action) => {
    if (action.reducer_type === 'reducer_privilege') {    
        switch (action.type) {
            case types.SET_ELEMENT_PARTY_MEMBER:
            return {
                ...state,
                itemPartyMembers: action.payload,
            };                    
        }
    }
    return state;
};

export default privilegePartyMemberReducer;